module.exports = __webpack_public_path__ + "img/top_image3.31f31192.png";